export default "__VITE_ASSET__77f1c5d7__"